import React from 'react';
import { Paper, Typography, Box, Divider } from '@mui/material';
import { getFullPath } from './BasicField';
import { SchemaRenderer } from './SchemaRenderer';

export const ObjectField = ({ basePath, field }) => {
  const path = getFullPath(basePath, field.key);

  return (
    <Paper
      variant="outlined"
      sx={{
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ mb: 1 }}>
        <Typography variant="h6" color="primary.main" sx={{ fontWeight: 600 }}>
          {field.label}
        </Typography>
        <Divider sx={{ mt: 1 }} />
      </Box>
      <Box sx={{ pl: 1 }}>
        <SchemaRenderer fields={field.itemSchema || []} basePath={path} />
      </Box>
    </Paper>
  );
};
